import React from "react";
import { SectionContainer, SectionWrap } from "../../globalOrganismStyles";
import MarketTraderList from "./MarketTraderList";

const MarketTraders = () => {
  return (
    <SectionContainer>
      <SectionWrap>
        <MarketTraderList />
      </SectionWrap>
    </SectionContainer>
  );
};

export default React.memo(MarketTraders)
